var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJobsSolid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_324_1865)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.66663 5.00033V4.16699C6.66663 2.78628 7.78591 1.66699 9.16663 1.66699H10.8333C12.214 1.66699 13.3333 2.78628 13.3333 4.16699V5.00033M1.66663 8.62323C1.66663 8.62323 4.26499 10.354 8.31468 10.7594M18.3333 8.62323C18.3333 8.62323 15.7349 10.354 11.6852 10.7594M4.99996 18.3337H15C16.8409 18.3337 18.3333 16.8413 18.3333 15.0003V8.33366C18.3333 6.49271 16.8409 5.00033 15 5.00033H4.99996C3.15901 5.00033 1.66663 6.49271 1.66663 8.33366V15.0003C1.66663 16.8413 3.15901 18.3337 4.99996 18.3337Z",
    stroke: "#7152F3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 10.1331V10.9665C11.6667 10.9748 11.6667 10.9748 11.6667 10.9831C11.6667 11.8915 11.6584 12.6331 10 12.6331C8.35004 12.6331 8.33337 11.8998 8.33337 10.9915V10.1331C8.33337 9.2998 8.33337 9.2998 9.16671 9.2998H10.8334C11.6667 9.2998 11.6667 9.2998 11.6667 10.1331Z",
    stroke: "#7152F3",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_324_1865"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobsSolid);
export default __webpack_public_path__ + "static/media/jobs-solid.34eadeed51f29cc3196969b933613765.svg";
export { ForwardRef as ReactComponent };